/* unplugin-vue-components disabled */import script from "./CurrencyModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CurrencyModal.vue?vue&type=script&lang=ts&setup=true"

import "./CurrencyModal.vue?vue&type=style&index=0&id=413e1a68&lang=less"

const __exports__ = script;

export default __exports__